import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "sweetshop-box";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const key = (category, name) => `${category}::${name}`;
    const add = (category, name, qty = 1) =>
      setItems((prev) => {
        const k = key(category, name);
        const found = prev.find((i) => i.key === k);
        if (found) return prev.map((i) => (i.key === k ? { ...i, qty: i.qty + qty } : i));
        return [...prev, { key: k, category, name, qty, note: "" }];
      });
    const update = (k, patch) => setItems((prev) => prev.map((i) => (i.key === k ? { ...i, ...patch } : i)));
    const setQty = (k, qty) =>
      setItems((prev) => (qty <= 0 ? prev.filter((i) => i.key !== k) : prev.map((i) => (i.key === k ? { ...i, qty } : i))));
    const qtyOf = (category, name) => items.find((i) => i.key === key(category, name))?.qty ?? 0;
    const count = items.reduce((s, i) => s + i.qty, 0);
    return { items, add, update, setQty, qtyOf, count, clear: () => setItems([]), open, setOpen };
  }, [items, open]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
};

export const useCart = () => useContext(CartCtx);
